export const COMPANY_NAME = "Murse Mark Holistic Big Picture Science LLC";
export const COMPANY_SHORT = "Murse Mark Holistic";
export const COMPANY_INITIALS = "MMH";
export const COMPANY_ADDRESS_FULL = "651 Chetwood St, Oakland, California 94610-1433";
export const COMPANY_LOCATION = "Oakland, California";
export const COMPANY_REGION = "Oakland, California";
export const MAP_URL = "https://www.google.com/maps/search/?api=1&query=651%20Chetwood%20St%2C%20Oakland%2C%20California%2094610-1433";
export const ABOUT_IMAGE_URL = "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?auto=format&fit=crop&w=1600&q=80";

export const PROFILE_FACTS = [
  { "label": "Profile type", "value": "Public directory profile" },
  { "label": "Location", "value": "Oakland, California" },
  { "label": "Address", "value": "651 Chetwood St" },
];

export const PUBLIC_INFO = [
  { "label": "Organization", "value": "Murse Mark Holistic Big Picture Science LLC" },
  { "label": "Location", "value": "Oakland, California" },
  { "label": "Address", "value": "651 Chetwood St, Oakland, California 94610-1433" },
];

export const CARE_PILLARS = [
  { "icon": "◐", "title": "Organization", "body": "Public listing for Murse Mark Holistic Big Picture Science LLC." },
  { "icon": "✦", "title": "Location", "body": "Based at a public Oakland, California address." },
  { "icon": "✿", "title": "Profile scope", "body": "A concise directory profile with verified public details." },
];
